export function formatDateDisplay(dateStr: string): string {
  const [year, month, day] = dateStr.split('-').map(Number);
  const dateObj = new Date(year, month - 1, day);
  return dateObj.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function isWeekInFuture(dateStr: string): boolean {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [year, month, day] = dateStr.split('-').map(Number);
  const weekDate = new Date(year, month - 1, day);
  return weekDate >= today;
}

export function getNextSundayDate(): string {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const daysUntilSunday = dayOfWeek === 0 ? 7 : 7 - dayOfWeek;
  const nextSunday = new Date(today);
  nextSunday.setDate(today.getDate() + daysUntilSunday);

  const year = nextSunday.getFullYear();
  const month = String(nextSunday.getMonth() + 1).padStart(2, '0');
  const day = String(nextSunday.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getCurrentOrNextSundayDate(): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dayOfWeek = today.getDay();
  const currentSunday = new Date(today);
  if (dayOfWeek !== 0) {
    currentSunday.setDate(today.getDate() + (7 - dayOfWeek));
  }

  const year = currentSunday.getFullYear();
  const month = String(currentSunday.getMonth() + 1).padStart(2, '0');
  const day = String(currentSunday.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
